<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M21 19.7v-9.5a1 1 0 0 0-.4-1l-8-5.8a1 1 0 0 0-1.3 0L3.5 9.3a1 1 0 0 0-.5.9v9.5A1 1 0 0 0 4.1 21h4.5a1 1 0 0 0 1.2-1.2v-3.3a1 1 0 0 1 1-1.2h2.3a1 1 0 0 1 1.2 1.2v3.3a1 1 0 0 0 1 1.2H20a1 1 0 0 0 1.1-1.2"
    />
    <path
      d="m20 10.1-8-6-8 6v9.7h4.7v-3.4a2 2 0 0 1 2.2-2.2H13a2 2 0 0 1 2.2 2.2v3.4H20zm2 9.6a2 2 0 0 1-2.1 2.2h-4.5a2 2 0 0 1-2.2-2.2v-3.4h-2.4v3.4A2 2 0 0 1 8.6 22H4.1A2 2 0 0 1 2 19.7v-9.5a2 2 0 0 1 .8-1.7l8-6a2 2 0 0 1 2.5 0l7.9 6a2 2 0 0 1 .8 1.7z"
    />
  </svg>
</template>
